// (c) TwistedMinds, Gerry Uytdenhouwen - 5 november 2026

/**
 * Maps a 422 answer of "Mijn gegevens" to the widget's own translation keys (without the "general." prefix).
 * Server texts are never passed on: they are in the backend language, not the widget's.
 *
 * @param {Object<string, string>} keysByField translation key per known field
 * @param {{errors?: Object<string, string[]>}|undefined} data the JSON body of the 422 answer
 * @returns {{fields: Object<string, string>, general: boolean}} fields = key per field with an error;
 *          general = something failed that has no field of its own (unknown field, or no errors at all)
 */
const mapErrors = (keysByField, data) => {
    const errors = data && data.errors && typeof data.errors === 'object' ? data.errors : {};
    const names = Object.keys(errors);
    const fields = {};
    let general = names.length === 0;
    names.forEach((name) => {
        if (Object.prototype.hasOwnProperty.call(keysByField, name)) {
            fields[name] = keysByField[name];
        } else {
            general = true;
        }
    });
    return {fields, general};
};

/**
 * Name / phone / e-mail block. `code: 'email_taken'` marks an address that belongs to another account.
 */
export const profileErrorKeys = (data) => {
    return mapErrors({
        name: 'profile-error-name',
        phone: 'profile-error-phone',
        email: data && data.code === 'email_taken' ? 'profile-email-taken' : 'profile-error-email',
    }, data);
};

/**
 * Change-password block.
 */
export const passwordErrorKeys = (data) => mapErrors({
    current_password: 'password-current-wrong',
    password: 'profile-error-password',
}, data);
